/**
 * Hierarchical Filter - Menu Navigation
 * Accordion toggle for L1/L2 nodes
 * Tap anywhere on the header row (except the link text) to toggle
 */
(function() {
  'use strict';

  var root = document.getElementById('HierarchicalFilter');
  if (!root) return;

  // Section title (top-level accordion) toggle
  root.querySelectorAll('[data-hf-section-toggle]').forEach(function(title) {
    title.addEventListener('click', function() {
      title.closest('.hf__section').classList.toggle('is-open');
    });
  });

  // Head area click toggles accordion (except direct link clicks)
  root.querySelectorAll('.hf__l1-head, .hf__l2-head').forEach(function(head) {
    head.addEventListener('click', function(e) {
      if (e.target.closest('a')) return;
      var node = head.closest('.hf__l1, .hf__l2');
      if (node) node.classList.toggle('is-open');
    });
  });

  // Arrow always toggles
  root.querySelectorAll('[data-hf-toggle]').forEach(function(arrow) {
    arrow.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      var node = arrow.closest('.hf__l1, .hf__l2');
      if (node) node.classList.toggle('is-open');
    });
  });
})();
